import { Component, OnInit } from '@angular/core';
import { ZoneService } from 'src/app/services/zone.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-list-zone',
  templateUrl: './list-zone.component.html',
  styleUrls: ['./list-zone.component.css']
})
export class ListZoneComponent implements OnInit {

  eventsSubject: Subject<any> = new Subject<any>();

  zonas: any[];
  tipos: any =[];
  displayedColumns: string[] = ['name','createdBy','createdAt','updatedBy', 'status', 'actions'];
  imageColumn = [ ]
  columnsToDisplay = [ {field: 'name', header: 'Nome', type: 'text'}, {field: 'createdAt', header: 'Data criação', type: 'date'},
  {field: 'createdBy', header: 'Criado por', type: 'text'}, {field: 'updatedBy', header: 'Editado por', type: 'text'}];
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados: [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: false, statusUpdate: false};
  title = 'Zonas';
  novo = {link: '/zonas/criar', nome: 'Nova zona'};
  page: any = {base: null, name: null};
  service;

  constructor(private zoneService: ZoneService,
    private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.zoneService.getAll;
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.id } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.id } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.zoneService.inactive(args.id);
      textConfirm = 'Pretende Desactivar a zona ' + args.name + '? Ao desactivar a zona o estado da zona será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'ZONA DESATIVADO COM SUCESSO';
    }
    else{
      service = this.zoneService.active(args.id);
      textConfirm = 'Pretende Activar a zona ' + args.name + '? Ao activar a zona o estado da zona será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'ZONA ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar esta zona ' + args.name + '? Ao eliminar os dados da zona serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.zoneService.delete(args.id).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }

